import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "./global/GlobalVars.js";
import axios from "axios";
import * as language from "./utils/language.js";
import * as navigation from "./utils/navigation.js";

import homeImage from "./images/icons/Home.png";
import backImage from "./images/icons/Zurück.png";
import alarmOffImage from "./images/icons/AlarmOff.png";
import alarmOnImage from "./images/icons/AlarmOn.png";
import alarmBlinkImage from "./images/icons/Alarm.gif";
import forwardImage from "./images/icons/PfeilVor.png";
import backwardImage from "./images/icons/PfeilZurueck.png";
import logoImage from "./images/icons/Logo_Profax.png";
import Menu from "./elements/System/Menu.jsx";
import DateTime from "./elements/System/DateTime.jsx";
import LanguageSelector from "./elements/System/LanguageSelector.jsx";
import { color } from "d3";

const Header = observer((props) => {
  //========================================================================
  // Mouse button 3 ("Zurück"-Taste) abfangen
  useEffect(() => {
    const handleMouseBackButton = (event) => {
      // Mouse button 3 ist meistens die "Zurück"-Taste
      if (event.button === 3) {
        event.preventDefault(); // blockiere Standardaktion
        navigation.changePage("back");
      }
    };

    window.addEventListener("mouseup", handleMouseBackButton);

    return () => {
      window.removeEventListener("mouseup", handleMouseBackButton);
    };
  }, []);

  //========================================================================
  // Mouse button 4 ("Vorwärts"-Taste) abfangen
  useEffect(() => {
    const handleMouseForwardButton = (event) => {
      // Mouse button 4 ist meistens die "Vorwärts"-Taste
      if (event.button === 4) {
        event.preventDefault(); // blockiere Standardaktion
        navigation.changePage("forward");
      }
    };

    window.addEventListener("mouseup", handleMouseForwardButton);

    return () => {
      window.removeEventListener("mouseup", handleMouseForwardButton);
    };
  }, []);

  //========================================================================
  // Anzahl Alarme anzeigen
  let alarmCount = 0;

  try {
    if (globalVars.activeAlarms.length < 100) {
      alarmCount = globalVars.activeAlarms.length.toString();
    } else {
      alarmCount = "99+";
    }
  } catch (error) {
    // console.error("Error accessing activeAlarms:", error);
  }

  //========================================================================
  // Downloads für Client
  const [clickCounter, setClickCounter] = useState(0);

  const downloadClientUtils = async () => {
    try {
      let newClickCounter = clickCounter + 1;
      setClickCounter(newClickCounter);

      if (clickCounter >= 24) {
        const userConfirmed = window.confirm(
          language.displayText([
            "Möchten Sie die Client-Utils wirklich herunterladen?",
            "Vuole davvero scaricare Client-Utils?",
            "Are you sure you want to download the Client Utils?",
          ]),
        );

        if (!userConfirmed) {
          setClickCounter(0);
          return;
        }

        const url =
          window.location.port === "3000"
            ? `http://${window.location.hostname}:${globalVars.httpPort}/project/download_client`
            : `/project/download_client`;

        const response = await axios.get(url, {
          responseType: "blob",
        });
        const blob = new Blob([response.data], { type: "application/zip" });

        const link = document.createElement("a");
        const objectUrl = window.URL.createObjectURL(blob);
        link.href = objectUrl;
        link.download = "client.zip";

        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(objectUrl);
        }, 100);

        setClickCounter(0);
      }
    } catch (err) {
      console.log(err);
      setClickCounter(0);
    }
  };

  return (
    <div className="header">
      {/* ######################################################################################################## */}
      {/* ################################################ Header ################################################ */}
      {/* ######################################################################################################## */}
      <header
        style={{
          height: "70px",
          backgroundColor: "black",
          color: "white",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 20px",
          userSelect: "none",
        }}
      >
        {/* ######################################################################################################## */}
        {/* ################################################ Titel ################################################# */}
        {/* ######################################################################################################## */}
        <div
          style={{
            fontSize: "32px",
            position: "absolute",
            display: "flex",
            justifyContent: "center",
            left: "0px",
            right: "0px",
          }}
        >
          {language.displayText(
            globalVars.pageProperties.currentPageConfig.pageTitle,
          )}
        </div>
        <div>
          {/* ######################################################################################################## */}
          {/* ################################################ Button Menü ########################################### */}
          {/* ######################################################################################################## */}
          <div
            style={{
              position: "absolute",
              left: "10px",
              top: "10px",
              width: "50px",
              height: "50px",
            }}
          >
            <Menu />
          </div>
          {/* ######################################################################################################## */}
          {/* ################################################ Button Home ########################################### */}
          {/* ######################################################################################################## */}
          <button
            className="navButton"
            title={language.displayText([
              "Startseite",
              "pagina iniziale",
              "startpage",
            ])}
            onClick={() => navigation.changePage("home")}
            style={{
              position: "absolute",
              left: "80px",
              top: "10px",
              width: "50px",
              height: "50px",
              backgroundImage: `url(${homeImage})`,
            }}
          ></button>
          {/* ######################################################################################################## */}
          {/* ################################################ Button Zurück ######################################### */}
          {/* ######################################################################################################## */}
          <button
            className="navButton"
            title={language.displayText([
              "letzte Seite",
              "ultima pagina",
              "last page",
            ])}
            onClick={() => navigation.changePage("back")}
            style={{
              position: "absolute",
              left: "150px",
              top: "10px",
              width: "50px",
              height: "50px",
              backgroundImage: `url(${backImage})`,
            }}
          ></button>
          {/* ######################################################################################################## */}
          {/* ################################################ Button Alarm ########################################## */}
          {/* ######################################################################################################## */}
          {globalVars.auth.alarm && (
            <div>
              <button
                className="navButton"
                style={{
                  visibility: "collapsed",
                  position: "absolute",
                  left: "220px",
                  top: "10px",
                  width: "50px",
                  height: "50px",

                  backgroundImage: `url(${
                    globalVars.alarmActive === 1
                      ? alarmBlinkImage
                      : globalVars.alarmActive === 2
                        ? alarmOnImage
                        : alarmOffImage
                  })`,
                }}
              ></button>
              <div
                style={{
                  visibility: "collapsed",
                  position: "absolute",
                  left: "220px",
                  top: "10px",
                  width: "50px",
                  height: "50px",
                  color: "white",
                  backgroundColor: "transparent",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                {alarmCount}
              </div>
              <button
                className="navButton"
                title={language.displayText(["Alarme", "allarmi", "alarms"])}
                onClick={() => navigation.changePage("alarm")}
                style={{
                  visibility: "collapsed",
                  position: "absolute",
                  left: "220px",
                  top: "10px",
                  width: "50px",
                  height: "50px",
                  opacity: "0",
                }}
              ></button>
            </div>
          )}
          {/* ######################################################################################################## */}
          {/* ################################################ Button Vorwärts ####################################### */}
          {/* ######################################################################################################## */}
          {globalVars.pageProperties.showButtonNavigateForward && (
            <button
              className="navButton"
              title={language.displayText([
                "Seite vor",
                "pagina successiva",
                "page before",
              ])}
              onClick={() => navigation.changePage("forward")}
              style={{
                position: "absolute",
                right: "350px",
                top: "10px",
                width: "50px",
                height: "50px",
                backgroundImage: `url(${forwardImage})`,
              }}
            ></button>
          )}
          {/* ######################################################################################################## */}
          {/* ################################################ Button Rückwärts ###################################### */}
          {/* ######################################################################################################## */}
          {globalVars.pageProperties.showButtonNavigateBackward && (
            <button
              className="navButton"
              title={language.displayText([
                "Seite zurück",
                "pagina precedente",
                "page back",
              ])}
              onClick={() => navigation.changePage("backward")}
              style={{
                position: "absolute",
                left: "350px",
                top: "10px",
                width: "50px",
                height: "50px",
                backgroundImage: `url(${backwardImage})`,
              }}
            ></button>
          )}

          {/* ######################################################################################################## */}
          {/* ################################################ Logo ################################################## */}
          {/* ######################################################################################################## */}
          <div
            style={{
              position: "absolute",
              right: "120px",
              top: "10px",
            }}
            onClick={() => downloadClientUtils()}
          >
            <img src={logoImage} width="162" height="50" />
          </div>

          {/* ######################################################################################################## */}
          {/* ################################################ Uhrzeit und Datum ##################################### */}
          {/* ######################################################################################################## */}
          <DateTime right={"10px"} top={"15px"} />
        </div>
      </header>
    </div>
  );
});

export default Header;
